import { useState } from 'react';

export default function BeforeAfter() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      label: 'Driveway Cleaning',
      before: 'https://static.readdy.ai/image/cd53c194d2b27431271da8b5defffc63/51d57d20fc8b99a416e759fa72ae6d9f.png',
      after: 'https://static.readdy.ai/image/cd53c194d2b27431271da8b5defffc63/4cba6b71bee572b2880f1d30e279dec8.png'
    },
    {
      label: 'Patio Cleaning',
      before: 'https://static.readdy.ai/image/cd53c194d2b27431271da8b5defffc63/c4b87bd3a045103bd83f794e897d1ae0.png',
      after: 'https://static.readdy.ai/image/cd53c194d2b27431271da8b5defffc63/2009ca54c069ec3a772943e2030e1e07.png'
    },
    {
      label: 'Walkway Restoration',
      before: 'https://static.readdy.ai/image/cd53c194d2b27431271da8b5defffc63/8a5f6fab6820a169dd90d0f0cccc8cd4.png',
      after: 'https://static.readdy.ai/image/cd53c194d2b27431271da8b5defffc63/cc170d66a9c1df6159a265284d6eb86d.png'
    },
    {
      label: 'Driveway Near Plants',
      before: 'https://static.readdy.ai/image/cd53c194d2b27431271da8b5defffc63/6011bfbc74e8966473ab6e12246ea37d.jpeg',
      after: 'https://static.readdy.ai/image/cd53c194d2b27431271da8b5defffc63/9397712f514a348ae78c08d422ec4f39.jpeg'
    },
    {
      label: 'Car Entryway Cleaning',
      before: 'https://static.readdy.ai/image/cd53c194d2b27431271da8b5defffc63/d9795f1f9ca3c51cbb4d6defe9a34936.jpeg',
      after: 'https://static.readdy.ai/image/cd53c194d2b27431271da8b5defffc63/25df67a8ea51ab7279c78012c3f02bf6.jpeg'
    }
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-extrabold text-blue-900 mb-4">
            See the Difference
          </h2>
          <div className="w-16 h-1 bg-gradient-to-r from-cyan-400 to-cyan-500 mx-auto mb-6"></div>
          <p className="text-lg text-blue-700 max-w-2xl mx-auto">
            Real results from our pressure cleaning services across Miami
          </p>
        </div>

        {/* Slider */}
        <div className="relative max-w-5xl mx-auto mb-12">
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {slides.map((slide, index) => (
                <div key={index} className="w-full flex-shrink-0 px-4">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Before */}
                    <div className="relative rounded-2xl overflow-hidden shadow-xl group">
                      <div className="w-full h-[500px]">
                        <img
                          src={slide.before}
                          alt={`${slide.label} - Before`}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div className="absolute top-4 left-4 bg-blue-900/90 backdrop-blur-sm text-white px-4 py-2 rounded-full font-bold text-sm">
                        Before
                      </div>
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-blue-900/90 to-transparent p-6">
                        <p className="text-white font-bold text-lg">{slide.label}</p>
                      </div>
                    </div>

                    {/* After */}
                    <div className="relative rounded-2xl overflow-hidden shadow-xl group">
                      <div className="w-full h-[500px]">
                        <img
                          src={slide.after}
                          alt={`${slide.label} - After`}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                      <div className="absolute top-4 left-4 bg-gradient-to-r from-cyan-400 to-cyan-500 text-white px-4 py-2 rounded-full font-bold text-sm">
                        After
                      </div>
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-cyan-900/90 to-transparent p-6">
                        <p className="text-white font-bold text-lg">{slide.label}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 bg-white rounded-full shadow-xl flex items-center justify-center hover:bg-cyan-500 hover:text-white transition-all duration-300 z-10"
            aria-label="Previous slide"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 bg-white rounded-full shadow-xl flex items-center justify-center hover:bg-cyan-500 hover:text-white transition-all duration-300 z-10"
            aria-label="Next slide"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>

          {/* Dots */}
          <div className="flex justify-center space-x-2 mt-8">
            {slides.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  currentSlide === index
                    ? 'bg-cyan-500 w-8'
                    : 'bg-blue-300 hover:bg-blue-400'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              ></button>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="tel:3052793585"
            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-cyan-400 to-cyan-500 text-white text-lg font-bold rounded-full hover:shadow-xl hover:scale-105 transition-all duration-300 whitespace-nowrap"
          >
            Want results like this? Call (305) 279-3585
            <i className="ri-phone-fill ml-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
